import React from 'react'
import '../ApplicationsDashboard/ApplicationsDashboard.css';
import './Reports.css';
import Sidebar from '../../components/Sidebar/Sidebar';
import SeedsLogo from "../../assets/images/SeedsLogo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faFileAlt,
    faChartBar,
    faDownload,
    faExternalLinkAlt,
    faClipboardList,
    faCheckDouble,
    faLayerGroup,
    faUsers,
    faMoneyBillWave,
} from "@fortawesome/free-solid-svg-icons";
import UserProfileDropdown from '../../components/UserProfile/UserProfile';
import { useNavigate } from 'react-router-dom';
import { BsArrowUpRight } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { getLeadReport } from '../../redux/ReportsReducer/action';
import axios from 'axios';
import { toast } from 'react-toastify';
import { isAuthorised } from '../../utils/common';
import { REPORTS_COMPONENTS } from '../../config/reports';

const Reports = () => {
    const { officerProfile } = useSelector((store) => {
        return {
          officerProfile: store.UserReducer.officerProfile,
        }
      }, []);

    let reports = [
        {
            report_id: 1,
            report_name: "Leads",
            report_description: "View and download all lead generation reports"
        },
        {
            report_id: 2,
            report_name: "Application",
            report_description: "Track application status and metrics"
        },
        {
            report_id: 3,
            report_name: "Limit Sanction",
            report_description: "Sanctioned limit reports and analysis"
        },
        {
            report_id: 4,
            report_name: "Tranche",
            report_description: "Tranche Limit Approved Details tracking reports"
        },
        {
            report_id: 5,
            report_name: "Supplier",
            report_description: "Supplier-wise transaction reports"
        },
        {
            report_id: 6,
            report_name: "Demand",
            report_description: "Demand generation and collection reports"
        },
        {
            report_id: 7,
            report_name: "Active Customer",
            report_description: "Active customer base reports"
        },
        {
            report_id: 8,
            report_name: "Repayment",
            report_description: "Repayment schedule and status reports"
        },
        {
            report_id: 9,
            report_name: "Payment Transaction",
            report_description: "Payment transaction history reports"
        },
        {
            report_id: 10,
            report_name: "Query Management",
            report_description: "Customer query management reports"
        },
    ]

    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    let tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
   let authToken = tokens?.token || null;

    const downloadReport = async (reportType) => {
    
        if (!authToken) {
            return;
        }

        let headers = {
            'Authorization': `Bearer ${authToken}`
        }

        const queryParams = new URLSearchParams({
            is_downloaded: true
        });

        let endpoint;

        if(reportType === "leads"){
            endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/get-lead-report?${queryParams.toString()}`;
        }
        else if(reportType === "applications"){
            endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/get-application-report?${queryParams.toString()}`;
        }
        else if(reportType === "limit-sanction"){
            endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/get-loan-report?${queryParams.toString()}`;
        }
        else if(reportType === "tranche"){
            endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/get-tranche-report?${queryParams.toString()}`;
        }
        else if(reportType === "supplier"){
            endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/get-supplier-report?${queryParams.toString()}`;
        }
        else if(reportType === "demand"){
            endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/get-demand-report?${queryParams.toString()}`;
        }
        else if(reportType === "repayment"){
            endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/get-rps-report?${queryParams.toString()}`;
        }
        else if(reportType === "active-customer"){
            endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/get-active-customer-report?${queryParams.toString()}`;
        }
        else if(reportType === "payment-transaction"){
            endpoint = `${process.env.REACT_APP_API_BASE_URL}/reports/payments-transaction-report?${queryParams.toString()}`;
        }

        try {
            const response = await axios.get(endpoint, { 
                headers, 
                responseType: "blob"    // for CSV/PDF/Excel 
            });

            console.log("Response headers:", response.headers);
            console.log("Response raw data:", response.data);

            const blob = new Blob([response.data], { type: "text/csv" });
            const blobUrl = window.URL.createObjectURL(blob);
        
            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', `${reportType}_${new Date().toISOString()}.csv`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
            console.log(error)
            toast.error(`Download failed: ${error?.response?.data?.message}`);
        }
    }

    const getReportKey = (reportName = "") => {
        const name = reportName.toLowerCase();

        if (name.includes("lead")) return "leads";
        if (name.includes("application")) return "applications";
        if (name.includes("limit sanction")) return "limit-sanction";
        if (name.includes("tranche")) return "tranche";
        if (name.includes("supplier")) return "supplier";
        if (name.includes("demand")) return "demand";
        if (name.includes("active customer")) return "active-customer";
        if (name.includes("repayment")) return "repayment";
        if (name.includes("payment transaction")) return "payment-transaction";
        if (name.includes("query management")) return "query-management";

        return "";
    };

    const getReportIcon = (reportName = "") => {
        const name = reportName.toLowerCase();
        if (name.includes("lead")) return faChartBar;
        if (name.includes("application")) return faClipboardList;
        if (name.includes("limit sanction")) return faCheckDouble;
        if (name.includes("tranche")) return faLayerGroup;
        if (name.includes("supplier")) return faUsers;
        if (name.includes("demand")) return faMoneyBillWave;
        if (name.includes("active customer")) return faUsers;
        if (name.includes("repayment")) return faClipboardList;
        if (name.includes("payment transaction")) return faMoneyBillWave;
        if (name.includes("query management")) return faFileAlt;
        return faFileAlt;
    };

    // Count how many reports the user has access to
    const availableReports = reports.filter(report => {
        const reportKey = getReportKey(report?.report_name);
        return isAuthorised(officerProfile, REPORTS_COMPONENTS[`${reportKey}_view`]) ||
               isAuthorised(officerProfile, REPORTS_COMPONENTS[`${reportKey}_download`]);
    });

    return (
        <div className="applicationsDashboardContainer">
            <div className="applicationsDashboard">
                <Sidebar />

                <div className="dashboardMainContent">
                    {/* --- Top Header --- */}
                    <div className="contentHeader">
                        <div className="userLogo">
                            <img src={SeedsLogo} alt="logo" className="SeedsLogo" />
                        </div>
                        <div className="headerRightPanel">
                            <UserProfileDropdown />
                        </div>
                    </div>

                    {/* --- Page Content --- */}
                    <div className="pageContentWrapper">
                        {/* Title */}
                        <div className="pageHeaderSection">
                            <div className="pageActions">
                                <h2>Reports</h2>
                            </div>
                        </div>

                        {/* --- Reports Table Card --- */}
                        <div className="tableCard">
                            <div className="applicationsTableContainer">
                                <table className="applications-table">
                                    <thead>
                                        <tr>
                                            <th>Report Name</th>
                                            <th>Description</th>
                                            <th style={{ textAlign: 'center' }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {reports.map((report, index) => {
                                            const reportKey = getReportKey(report?.report_name);
                                            const hasView = isAuthorised(officerProfile, REPORTS_COMPONENTS[`${reportKey}_view`]);
                                            const hasDownload = isAuthorised(officerProfile, REPORTS_COMPONENTS[`${reportKey}_download`]);

                                            if (!hasView && !hasDownload) return null;

                                            return (
                                                <tr key={report.report_id}>
                                                    <td>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                            <div className="reportIconWrapper">
                                                                <FontAwesomeIcon icon={getReportIcon(report?.report_name)} className="reportRowIcon" />
                                                            </div>
                                                            <span style={{ fontWeight: 600, color: '#1e293b' }}>{report?.report_name}</span>
                                                        </div>
                                                    </td>
                                                    <td style={{ color: '#64748b', fontSize: '13px' }}>{report?.report_description || 'View and download report'}</td>
                                                    <td style={{ verticalAlign: 'middle' }}>
                                                        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', alignItems: 'center' }}>
                                                            {hasView && (
                                                                <button
                                                                    className="reportViewBtn"
                                                                    onClick={() => navigate(`/reports/${reportKey}`)}
                                                                >
                                                                    <FontAwesomeIcon icon={faExternalLinkAlt} style={{ fontSize: '11px' }} />
                                                                    View
                                                                </button>
                                                            )}
                                                            {hasDownload && (
                                                                <button
                                                                    className="reportDownloadBtn"
                                                                    onClick={() => downloadReport(reportKey)}
                                                                >
                                                                    <FontAwesomeIcon icon={faDownload} style={{ fontSize: '11px' }} />
                                                                    Download
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Reports